export const DAYS = ['일', '월', '화', '수', '목', '금', '토'];
